/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'
import SwiperCore, { Navigation, Pagination, EffectFade, FreeMode, Thumbs } from 'swiper'
import uuid from 'uuid'
// icon
import CityBgMO from '@assets/images/casino/casino-top-bg-MO.jpg'
import CityBgPC from '@assets/images/casino/casino-top-bg-PC.jpg'
import BaccaratGuideBtnImg from '@assets/images/casino/baccarat-guide-btn.jpg'
import OpenImg from '@assets/images/casino/casino-open.jpg'
import BaccaratTitleImg from '@assets/images/casino/casino-title.jpg'
import BaccaratContentsImg from '@assets/images/casino/casino-contents.jpg'
// import CasinoPCGuideImg from '@assets/images/casino/casino-pc-guide.jpg'
import DiaEventBtnImg from '@assets/images/casino/dia-event-btn.jpg'
import LightImg01 from '@assets/images/casino/light-01.png'
import LightImg02 from '@assets/images/casino/light-02.png'
import LightImg03 from '@assets/images/casino/light-03.png'
import Firework01 from '@assets/images/casino/firework-01.png'
import Firework02 from '@assets/images/casino/firework-02.png'
import Firework03 from '@assets/images/casino/firework-03.png'
import CasinoLogo from '@assets/images/casino/casino-logo.png'
import NavBar from '@views/Navbar'
// css
import { BackBtn, Button } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { CarouselWrap } from '@views/Matchup/MatchUpBanner/index.style'
import BaccaratGuideImg01 from '@assets/images/casino/casino-pc-thum01.png'
import BaccaratGuideImg02 from '@assets/images/casino/casino-pc-thum02.png'
import BaccaratGuideImg03 from '@assets/images/casino/casino-pc-thum03.png'
import BaccaratGuideImg04 from '@assets/images/casino/casino-pc-thum04.png'
import { TitleWrap } from '@styles/base.style'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import _ from 'lodash'
import { AdvCasinoWrap } from './index.style'
import PopupUtils from '@utils/popup-utils'

SwiperCore.use([Navigation, Pagination, EffectFade, FreeMode, Thumbs])

if (!isMobile) {
  SwiperCore.extendDefaults({ allowTouchMove: false })
}

const AdvCasino: React.FC = () => {
  const { globalStore, routerStore, componentStore } = useRootStore()

  const [thumbsSwiper, setThumbsSwiper] = useState(null)

  const onClickBaccaratGuide = () => {
    globalStore.setVisibleBaccaratGuidePopup(true)
  }

  const list = [
    {
      tutorialImgUrl: BaccaratGuideImg01,
      closeBtn: false,
    },
    {
      tutorialImgUrl: BaccaratGuideImg02,
      closeBtn: false,
    },
    {
      tutorialImgUrl: BaccaratGuideImg03,
      closeBtn: false,
    },
    {
      tutorialImgUrl: BaccaratGuideImg04,
      closeBtn: false,
    },
  ]

  // 튜토리얼 이미지
  const slides = list.map((tutorial, index) =>
    <Fragment key={uuid.v4()}>
      <img key={`MatchUpBanner:Swiper:Slide:${String(index)}`} src={tutorial.tutorialImgUrl} alt="튜토리얼 이미지" className="img"/>
    </Fragment>,
  )

  let contents

  if (isMobile) {
    contents = <img src={BaccaratContentsImg} alt="승부사바카라 모바일" style={{ width: '100%' }}/>
  } else {
    contents = (
      <CarouselWrap className="carousel-wrap">
        <Swiper
          modules={[Thumbs]}
          thumbs={{ swiper: thumbsSwiper }}
          effect='fade'
          navigation
          loop={false}
        >
          {slides.map((slideImg, index) => (
            <SwiperSlide key={`MatchUpBanner:Swiper:Slide:Item:${String(index)}`}>
              {slideImg}
            </SwiperSlide>
          ))}
        </Swiper>

        <Swiper
          modules={[Thumbs]}
          watchSlidesProgress
          onSwiper={setThumbsSwiper}
          freeMode
          spaceBetween={6}
          slidesPerView={4}
          loop={false}
        >
          {slides.map((slideImg, index) => (
            <SwiperSlide key={`MatchUpBanner:Swiper:Slide:Item:${String(index)}`}>
              {slideImg}
            </SwiperSlide>
          ))}
        </Swiper>
      </CarouselWrap>
    )
  }

  // const pcGuideImg = <img src={CasinoPCGuideImg} alt="승부사카지노 PC 이용 방법" style={{ width: '100%', marginTop: '90px' }}/>

  // 다이아 이벤트 참여 버튼
  const onClickDiaEvent = () => {
    const { matchupBanners } = componentStore
    const banner = _.find(matchupBanners.banners, banner => banner.order === 2)
    componentStore.setSelectedGameBanner(banner)
    PopupUtils.showMatchupBannerPopup()
  }

  return (
    <Fragment>
      {isMobile && (
        <TitleWrap className="title-wrap no-bg">
          <BackBtn onClick={() => routerStore.goBack()}>
            <ArrowIco/>
          </BackBtn>
        </TitleWrap>
      )}

      <AdvCasinoWrap className={!isMobile && 'pc-adv-casino-wrap'}>
        <img src={isMobile ? CityBgMO : CityBgPC} alt="다이아로 즐기는 바카라 승부사카지노" style={{ width: '100%' }}/>

        <div className="star-wrap">
          <span className="star star-01"/>
          <span className="star star-02"/>
          <span className="star star-03"/>
          <span className="star star-04"/>
          <span className="star star-05"/>
          <span className="star star-06"/>
          <span className="star star-07"/>
          <span className="star star-08"/>
          <span className="star star-09"/>
          <span className="star star-10"/>
          <span className="star star-11"/>
        </div>

        <div className="firework-wrap">
          <img src={Firework01} alt="폭죽1" className="firework firework-01"/>
          <img src={Firework02} alt="폭죽2" className="firework firework-02"/>
          <img src={Firework03} alt="폭죽3" className="firework firework-03"/>
        </div>

        <div className="light-wrap">
          <img src={LightImg01} alt="빛1" className="light-img light-img-01"/>
          <img src={LightImg02} alt="빛2" className="light-img light-img-02"/>
          <img src={LightImg03} alt="빛3" className="light-img light-img-03"/>
        </div>

        <img src={CasinoLogo} alt="다이아로 즐기는 바카라" className="casino-logo"/>

        <iframe width="100%" height="auto" src="https://www.youtube.com/embed/cNny179IsQY" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="casino-video"/>
        <Button TP className="casino-guide-btn" onClick={onClickBaccaratGuide}>
          <img src={BaccaratGuideBtnImg} alt="바카라란" style={{ width: '100%' }}/>
        </Button>
        <img src={OpenImg} alt="OPEN 1월 초 예정" style={{ width: '100%', marginBottom: '30px' }}/>
        <img src={BaccaratTitleImg} alt="20초마다의 빠른 승부 승부사바카라 다이아로 바카라 게임을 즐겨보세요" style={{ width: '100%' }}/>
        {/* 인게임 캡쳐(강점 소개) */}
        {contents}

        {/* PC 이용 방법 이미지 */}
        {/* 오픈 후 노출할 예정 */}
        {/*{!isMobile && pcGuideImg}*/}

        {/* 다이아 이벤트 참여 버튼 */}
        <Button TP className={isMobile ? 'dia-event-btn' : 'dia-event-btn pc-btn'} onClick={onClickDiaEvent}>
          <img src={DiaEventBtnImg} alt="다이아 이벤트 참여하기" style={{ width: '100%' }}/>
        </Button>
      </AdvCasinoWrap>

      {isMobile && <NavBar key="MyPage:NavBar"/>}
    </Fragment>
  )
}

export default observer(AdvCasino)
